import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { useParsedQueryParams } from "@js/hooks";
import { useLatestCallback } from "@js/hooks/use-latest-callback";

import { registerFormPrefillSchema, registerPrefillParams } from "../../utils";

export const useNewFreelancerRegisterPrefillData = () => {
  const [, setSearchParams] = useSearchParams();
  const { data } = useParsedQueryParams(registerFormPrefillSchema);

  const [freelancerRegisterPrefillData] = useState(data);

  const searchParamsRef = useLatestCallback(setSearchParams);
  useEffect(() => {
    if (!freelancerRegisterPrefillData) {
      return;
    }

    searchParamsRef(
      (prev) => {
        const paramsCopy = new URLSearchParams(prev);
        for (const key of registerPrefillParams) {
          paramsCopy.delete(key);
        }

        return paramsCopy;
      },
      { replace: true },
    );
  }, [freelancerRegisterPrefillData, searchParamsRef]);

  return { freelancerRegisterPrefillData };
};
